// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-l_he","advertDetailContacts__header":"c-l_hf"};